import { IRoute } from "@src/routes";
import ListProgramPage from "./programs/pages/ListProgramPage";
import CreateFixedDiscountRulePage from "./register/pages/CreateFixedDiscountRulePage";
import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/refund/fixed-discount-rule/new",
    key: "REFUND_PROGRAM_LIST",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListProgramPage,
  },
  {
    path: "/refund/fixed-discount-rule/new/:programCode",
    key: "REFUND_FIXED_DISCOUNT_RULE_CREATE",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: CreateFixedDiscountRulePage,
  },
];

export default routes;
